import React from "react";
import FormattedMessage from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Headings";
import { Label2 } from "@irati/ui/src/Labels";
import RequestNewLinkButton from "../../components/UserOnboarding/RequestNewLinkButton";
/** @description: This will be the V2 onboarding container once v4 goes live */
var RequestNewLink = function () {
    return (React.createElement("div", null,
        React.createElement(H2, { small: true },
            React.createElement(FormattedMessage, { id: "onboarding.old.header" })),
        React.createElement(Label2, null,
            React.createElement(RequestNewLinkButton, { body: "onboarding.old.body" }))));
};
export default RequestNewLink;
